const CLIENT_IDENTIFIERS = {
  LONG_BEACH: 72665,
  REDONDO_BEACH: 350070,
  MED_RESPONSE: 351203,
};

export default CLIENT_IDENTIFIERS;
